import React, { useState } from 'react';
import axios from '../config/axios';
import AvatarPicker from './AvatarPicker';
import { getAuthHeaders } from '../utils/auth';
import '../assets/styles/ParentDashboard.css';

export default function KidAvatarSettings({ user, onBack, onAvatarUpdate }) {
    const [selectedAvatar, setSelectedAvatar] = useState(user?.avatar || '😊');
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    const handleSave = async () => {
        setSaving(true);
        setMessage('');
        
        try {
            const response = await axios.post('/api/v1/users/update-avatar', {
                user_id: user.user_id || user.id,
                avatar: selectedAvatar
            }, {
                headers: getAuthHeaders()
            });

            setMessage('Avatar updated successfully! 🎉');
            
            if (onAvatarUpdate) {
                onAvatarUpdate(response.data);
            }

            setTimeout(() => {
                onBack();
            }, 1500);
        } catch (err) {
            console.error('Failed to update avatar:', err);
            setMessage('Failed to update avatar. Please try again.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="dashboard-container">
            <header className="dashboard-header" style={{ 
                background: 'linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)',
                padding: '24px',
                borderRadius: '16px',
                marginBottom: '32px'
            }}>
                <div className="header-left" style={{ display: 'flex', alignItems: 'center' }}>
                    <button 
                        onClick={onBack}
                        style={{
                            background: 'white',
                            border: 'none',
                            color: '#ec4899',
                            fontSize: '1rem',
                            fontWeight: '700',
                            cursor: 'pointer',
                            marginRight: '20px',
                            padding: '12px 24px',
                            borderRadius: '8px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                        }}
                    >
                        <span style={{ fontSize: '1.2rem' }}>←</span>
                        <span>Back to Dashboard</span>
                    </button>
                    <div>
                        <h1 style={{ color: 'white', margin: 0 }}>Change Your Avatar</h1>
                        <p style={{ color: 'rgba(255,255,255,0.9)', margin: '4px 0 0 0', fontSize: '0.95rem' }}>
                            Pick a new avatar that represents you! ✨
                        </p>
                    </div>
                </div>
            </header>

            <div style={{ 
                maxWidth: '600px', 
                margin: '0 auto', 
                padding: '40px 20px',
                textAlign: 'center'
            }}>
                <div style={{
                    background: 'white',
                    borderRadius: '16px',
                    padding: '40px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <h2 style={{ marginBottom: '8px', color: '#111827' }}>Your Current Avatar</h2>
                    <p style={{ color: '#6b7280', marginBottom: '32px' }}>
                        Click on the avatar below to choose a new one!
                    </p>

                    <AvatarPicker
                        selectedAvatar={selectedAvatar}
                        onSelect={setSelectedAvatar}
                        size="large"
                    />

                    {message && (
                        <div style={{
                            marginTop: '24px',
                            padding: '12px 20px',
                            borderRadius: '8px',
                            background: message.includes('success') ? '#d1fae5' : '#fee2e2',
                            color: message.includes('success') ? '#065f46' : '#991b1b',
                            fontWeight: '600'
                        }}>
                            {message}
                        </div>
                    )}

                    <div style={{ 
                        marginTop: '32px',
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'center'
                    }}>
                        <button
                            onClick={onBack}
                            style={{
                                padding: '12px 24px',
                                borderRadius: '8px',
                                border: '2px solid #e5e7eb',
                                background: 'white',
                                color: '#6b7280',
                                fontSize: '1rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleSave}
                            disabled={saving || selectedAvatar === user?.avatar}
                            style={{
                                padding: '12px 32px',
                                borderRadius: '8px',
                                border: 'none',
                                background: selectedAvatar === user?.avatar ? '#d1d5db' : 'linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)',
                                color: 'white',
                                fontSize: '1rem',
                                fontWeight: '700',
                                cursor: selectedAvatar === user?.avatar ? 'not-allowed' : 'pointer',
                                transition: 'all 0.2s ease',
                                boxShadow: selectedAvatar === user?.avatar ? 'none' : '0 4px 12px rgba(236, 72, 153, 0.3)'
                            }}
                        >
                            {saving ? 'Saving...' : 'Save Avatar'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
